/**
 * DIA DO CALENDÁRIO LOCAL — sem o deslocamento de um dia do UTC.
 *
 * O padrão espalhado pelo código era:
 *
 *     new Date().toISOString().split('T')[0]
 *
 * `toISOString()` converte para **UTC**. No Brasil (UTC-3), das 21h à
 * meia-noite o dia UTC já é o seguinte — então uma Inspeção aberta às 21h30
 * de 25/09 nascia datada de **26/09**, e essa data sai impressa no
 * Relatório de Integridade como o período da inspeção. O mesmo vale para a
 * validade de calibração de instrumentos e dispositivos de segurança.
 *
 * No filtro de listas o efeito é o inverso e igualmente silencioso: um
 * registro gravado às 22h local vira o dia seguinte em UTC e **some** do
 * filtro do dia em que de fato aconteceu.
 *
 * Aqui o dia vem dos componentes locais da data, que é o que o usuário vê
 * no relógio e digita num `<input type="date">`.
 */

const pad = (value: number): string => String(value).padStart(2, "0");

/** `AAAA-MM-DD` do calendário LOCAL de uma data. */
export function localDayOf(value: Date | string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** `AAAA-MM-DD` de hoje, no calendário local. */
export function todayLocalDay(now: Date = new Date()): string {
  return localDayOf(now);
}

/** Hoje deslocado em `days` dias, no calendário local (aceita negativo). */
export function localDayPlus(days: number, now: Date = new Date()): string {
  const shifted = new Date(now.getTime());
  shifted.setDate(shifted.getDate() + days);
  return localDayOf(shifted);
}
